import React from 'react';

/**
 * AdminStats — Top-level platform statistics cards.
 * Shows house revenue, volume, active bets, and users at a glance.
 */
const AdminStats = ({ houseFee, pools, bets, ledger }) => {
    // Total pool volume across all coins/slots
    const totalVolume = Object.values(pools).reduce(
        (acc, p) => acc + (p.up || 0) + (p.down || 0), 0
    );

    // Active (locked, unsettled) bets
    const activeBets = Object.values(bets).filter(b => b.locked && !b.settled);
    const activeVolume = activeBets.reduce((acc, b) => acc + Number(b.amount || 0), 0);

    // Settled bet count
    const settledCount = ledger.length;

    // Win rate
    const wins = ledger.filter(e => e.result === 'WIN').length;
    const winRate = settledCount > 0 ? ((wins / settledCount) * 100).toFixed(1) : '0.0';

    const stats = [
        {
            label: 'House Revenue',
            value: `$${houseFee.toLocaleString(undefined, { maximumFractionDigits: 2 })}`,
            accent: 'text-amber-400',
            glow: 'shadow-[0_0_20px_rgba(245,158,11,0.1)]',
        },
        {
            label: 'Total Pool Volume',
            value: `$${totalVolume.toLocaleString(undefined, { maximumFractionDigits: 2 })}`,
            accent: 'text-blue-400',
            glow: 'shadow-[0_0_20px_rgba(59,130,246,0.1)]',
        },
        {
            label: 'Active Bets',
            value: `${activeBets.length}`,
            sub: `$${activeVolume.toLocaleString(undefined, { maximumFractionDigits: 2 })} locked`,
            accent: 'text-emerald-400',
            glow: 'shadow-[0_0_20px_rgba(16,185,129,0.1)]',
        },
        {
            label: 'Settlements',
            value: `${settledCount}`,
            sub: `${winRate}% user win rate`,
            accent: 'text-purple-400',
            glow: 'shadow-[0_0_20px_rgba(139,92,246,0.1)]',
        },
    ];

    return (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
            {stats.map(({ label, value, sub, accent, glow }) => (
                <div
                    key={label}
                    className={`border border-white/5 bg-white/[0.02] rounded-lg p-5 ${glow}`}
                >
                    <span className="text-xs uppercase tracking-[0.25em] text-gray-500 font-bold">
                        {label}
                    </span>
                    <div className={`text-2xl font-mono font-black mt-1 ${accent}`}>
                        {value}
                    </div>
                    {sub && (
                        <span className="text-sm text-gray-600 font-mono mt-1 block">
                            {sub}
                        </span>
                    )}
                </div>
            ))}
        </div>
    );
};

export default AdminStats;
